module.exports = __webpack_public_path__ + "img/FR43899.b140fbe4.png";